import Vue from 'vue'

Vue.filter('ellipsis', (v: string, maxLen: number) => {
  if (!v) {
    return ''
  }
  if (v.length <= maxLen) {
    return v
  }
  return `${v.substr(0, maxLen - 3)}...`
})

Vue.filter('newline2br', (v: string, maxLen: number) => {
  if (!v) {
    return ''
  }
  return `${v.replaceAll(/\n/g, '<br>')}`
})
